import { yupResolver } from '@hookform/resolvers/yup';
import ControllerSelect from 'Components/ControllerSelect';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import UsersService from 'Services/Http/Users.service';
import { idUserSchema } from 'Services/yup/form';
import PropTypes from 'prop-types';

const SelectUsers = (props) => {
  const { onChange } = props;
  const {
    control,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      idUser: ''
    },
    resolver: yupResolver(idUserSchema)
  });
  const [users, setUsers] = useState([]);
  const idUserChanged = watch('idUser');

  useEffect(() => {
    console.log(idUserChanged);
    onChange(idUserChanged);
  }, [idUserChanged]);

  const getUsers = async () => {
    try {
      const responseUsers = await UsersService.getAllUsers();
      const usersOptions = responseUsers.data.map((user) => ({
        label: user.nombreCompleto,
        value: user.id
      }));
      setUsers(usersOptions);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <ControllerSelect
      data={users}
      control={control}
      name="idUser"
      error={errors?.idUser}
      label="Seleccionar Usuario"
    />
  );
};

SelectUsers.propTypes = {
  onChange: PropTypes.func
};

export default SelectUsers;
